import { createSlice } from '@reduxjs/toolkit';

interface ParentFrameCommunicatorState {
    initConnectionMessageReceived: boolean;
}

const initialState: ParentFrameCommunicatorState = {
    initConnectionMessageReceived: false,
};

const parentFrameCommunicatorSlice = createSlice({
    name: 'parentFrameCommunicator',
    initialState,
    reducers: {
        initConnectionMessageReceivedAction(state: ParentFrameCommunicatorState) {
            state.initConnectionMessageReceived = true;
        },
    },
});

export const { initConnectionMessageReceivedAction } = parentFrameCommunicatorSlice.actions;
export const parentFrameCommunicatorReducer = parentFrameCommunicatorSlice.reducer;
